import type { SourcingEventDto } from "../../../autogen/bff-api";

export type CommunicationSubTab =
  | "questions"
  | "publicQa"
  | "information"
  | "clarifications"
  | "internal";

export const communicationSubTabs = (event: SourcingEventDto): CommunicationSubTab[] =>
  event.eventContext.type === "Public"
    ? ["questions", "publicQa", "information", "clarifications", "internal"]
    : ["questions", "information", "clarifications", "internal"];

export const parseCommunicationSubTab = (
  value: string | null,
  visible: CommunicationSubTab[],
): CommunicationSubTab => {
  const found = visible.find((subTab) => subTab === value);
  return found ?? visible[0];
};
